var map = {
	"./alert-circle.svg": "4c57",
	"./avatars/opponent-defi.svg": "c492",
	"./avatars/opponent.svg": "243e",
	"./avatars/player.svg": "0338",
	"./barcode.svg": "de34",
	"./bg-medal.svg": "e7a6",
	"./bubble-bottom.svg": "bbca",
	"./bubble.svg": "a6a5",
	"./button-loader.svg": "c301",
	"./charade-arrow-left.svg": "3b31",
	"./charade-arrow-right.svg": "a72a",
	"./charade-false-icon.svg": "a330",
	"./charade-false.svg": "206a",
	"./charade-true-icon.svg": "af85",
	"./charade-true.svg": "2940",
	"./check.svg": "6aa8",
	"./chevron-right-red.svg": "bba4",
	"./chevron-right.svg": "42fd",
	"./close.svg": "1d1b",
	"./double-arrow-light.svg": "e21f",
	"./i-info.svg": "6802",
	"./loader.svg": "281f",
	"./login/alert-triangle.svg": "7617",
	"./logo-oqlf-colors.svg": "a72b",
	"./logo-oqlf-marges.svg": "55ea",
	"./logo-white.svg": "e1d6",
	"./logo.svg": "1ae4",
	"./logout.svg": "0627",
	"./map-africa.svg": "c7da",
	"./map-water.svg": "c296",
	"./medal-bronze-light.svg": "dfa4",
	"./medal-bronze.svg": "c1cc",
	"./medal-gold-light.svg": "6f54",
	"./medal-gold.svg": "0ac0",
	"./medal-silver-light.svg": "2530",
	"./medal-silver.svg": "f72e",
	"./offline-stripe.svg": "cdc5",
	"./passeport-notification.svg": "bddf",
	"./plane.svg": "6b2a",
	"./planet.svg": "6437",
	"./present.svg": "12a9",
	"./scroll/scroll-arrow-down.svg": "a5ad",
	"./scroll/scroll-arrow-up.svg": "8e83",
	"./settings.svg": "1354",
	"./star-gray.svg": "9814",
	"./star-white.svg": "38d1",
	"./star-yellow.svg": "41db",
	"./trivia-error-opponent.svg": "0857",
	"./trivia-error-player.svg": "8430",
	"./trivia-success-player.svg": "2b68",
	"./trivia-success.svg": "f3a9",
	"./trophy.svg": "3263"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";